import React, { useState } from "react";
import { useEffect } from "react";
// import { useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { useGetRoiIncomeDataUserChartQuery } from "../../../../Services/earningApi";

const RoiIncomeBarchart = () => {
  const { data: roiIncomeChart } = useGetRoiIncomeDataUserChartQuery();
  /* graph state */
  const [state, setState] = useState({
    series: [
      {
        name: "daily Roi income",
        data: [],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        foreColor: "orange",
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        type: "datetime",
        categories: [],
      },
      yaxis: {
        title: {
          text: "$USD",
        },
      },
      fill: {
        opacity: 0.5,
      },
      tooltip: {
        x: {},
        y: {
          formatter: function (val) {
            return "$ " + val + "USD";
          },
        },
      },
    },
  });

  useEffect(() => {
    const createIncomeLevelData = async () => {
      const newObj = {
        series: [
          {
            name: "daily Roi income",
            data: roiIncomeChart?.roiIncomeDailyTotal,
          },
        ],
        options: {
          chart: {
            type: "bar",
            height: 350,
            foreColor: "orange",
            toolbar: {
              show: true,
              tools: {
                download: false,
              },
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 1,
            colors: ["transparent"],
          },
          xaxis: {
            type: "datetime",
            categories: roiIncomeChart?.roiIncomeDailyDate,
          },
          yaxis: {
            title: {
              text: "$USD",
            },
          },
          fill: {
            opacity: 0.5,
          },
          tooltip: {
            x: { show: false },
            y: {
              formatter: function (val) {
                return "$ " + val + "USD";
              },
            },
          },
        },
      };
      // console.log(newObj);
      await setState(newObj);
    };
    createIncomeLevelData();
  }, [roiIncomeChart?.roiIncomeDailyDate, roiIncomeChart?.roiIncomeDailyTotal]);
  console.log(roiIncomeChart);
  return (
    <div id="chart">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="bar"
        height={150}
      />
    </div>
  );
};

export default RoiIncomeBarchart;
